export default function CarouselTitle({ title, id }) {
  return (
    <h4
      className='mx-2 md:mx-6 my-3 text-blue-900'
      dangerouslySetInnerHTML={{ __html: title?.html }}
      data-testid={`${id}-carousel-title`}
    />
  );
}
